import { render, staticRenderFns } from "./VendorPhotosDisplay.vue?vue&type=template&id=ce28664a&scoped=true&"
import script from "./VendorPhotosDisplay.vue?vue&type=script&lang=js&"
export * from "./VendorPhotosDisplay.vue?vue&type=script&lang=js&"
import style0 from "./VendorPhotosDisplay.vue?vue&type=style&index=0&id=ce28664a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce28664a",
  null
  
)

export default component.exports